// extracted by mini-css-extract-plugin
module.exports = {"checkboxName":"_1JmODF5RW5yIX7064clWmn"};